import { arrayBufferToHex } from '../../services/buffers'

function stringToArrayBuffer(str: string) {
  let encoder = new TextEncoder()
  return encoder.encode(str).buffer
}

const hashBuffer = async (buffer: BufferSource) => {
  const hashBuffer = await crypto.subtle.digest('SHA-256', buffer)
  return arrayBufferToHex(hashBuffer)
}

export const getImageHashFromFile = async (file: File): Promise<string> => {
  const { name, size, lastModified } = file
  return hashBuffer(stringToArrayBuffer(`${name}${size}${lastModified}`))
}

export const getImageHashFromUrl = async (url: string): Promise<string> => {
  return hashBuffer(stringToArrayBuffer(url))
}
